import React, {Component} from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

class ListFilter extends Component {
    static propTypes = {
        collection: PropTypes.arrayOf(
            PropTypes.object.isRequired
        ).isRequired
    }

    apply(){
        let state = {}
        this.props.collection.map((e) => {
            state[e.name] = e.node.props.value
        });
        this.props.dispatch(state);
        //this.setState(state);
    }

    reset(){
        this.init();
    }

    render() {
        return <div className="list-filters">
            <ul>
                {this.props.collection.map((filter, i) =>
                    filter
                )}
            </ul>
            <button onClick={this.apply.bind(this)}><Label>app.valid</Label></button>
            <button onClick={this.reset.bind(this)}><Label>app.cancel</Label></button>
        </div>
    }
}

export default connect()(ListFilter)
